/* 模拟服务器地址 */
export default 'http://result.eolinker.com/bXzfsdc02da8998d27311355c7bad09117b8b33850d6a2f?uri='



// WEBPACK FOOTER //
// ./src/utils/url.js